'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getCountryInfo = getCountryInfo;
exports.getFormattedDob = getFormattedDob;
exports.validateDob = validateDob;
/**
 * Localization Utilities
 *
 * Helps to solve problems when working with different countries and locales.
 * Makes it easier when validating, formatting, getting date values.
 *
 */

/**
 * The list of all supported localized countries and their settings.
 */
var countryInfo = {
	US: {
		showDOB: false,
		showOccupation: false,
		showNationality: false,
		showLegalCheckBox: true,
		showLegalTextOnly: false,
		showPasswordHint: false,
		showConsentCheckBox: false,
		DOBPattern: 'MM/DD/YYYY',
		occupations: []
	},
	CA: {
		showDOB: true,
		showOccupation: true,
		showNationality: false,
		showLegalCheckBox: false,
		showLegalTextOnly: true,
		showPasswordHint: true,
		showConsentCheckBox: true,
		DOBPattern: 'MM/DD/YYYY',
		occupations: [{ label: 'Accounting' }, { label: 'Administration' }, { label: 'Arts, Culture' }, { label: 'Business' }, { label: 'Communications' }, { label: 'Customer Service' }, { label: 'Education' }, { label: 'Energy, Utilities' }, { label: 'Engineering' }, { label: 'Finance' }, { label: 'Financial Services' }, { label: 'Government' }, { label: 'Health' }, { label: 'Hospitality' }, { label: 'Human Resources' }, { label: 'Internet' }, { label: 'Legal' }, { label: 'Manufacturing' }, { label: 'Marketing' }, { label: 'Non-profit' }, { label: 'Recreation' }, { label: 'Religion' }, { label: 'Research' }, { label: 'Sales' }, { label: 'Sports, Fitness' }, { label: 'Student' }, { label: 'Technology' }, { label: 'Trade' }, { label: 'Transportation' }, { label: 'Travel' }]
	},
	GB: {
		showDOB: true,
		showOccupation: false,
		showNationality: true,
		showLegalCheckBox: true,
		showLegalTextOnly: false,
		showPasswordHint: true,
		showConsentCheckBox: false,
		DOBPattern: 'DD/MM/YYYY',
		occupations: []
	},
	AU: {
		showDOB: true,
		showOccupation: false,
		showNationality: false,
		showLegalCheckBox: false,
		showLegalTextOnly: true,
		showPasswordHint: true,
		showConsentCheckBox: true,
		DOBPattern: 'DD/MM/YYYY',
		occupations: []
	},
	FR: {
		showDOB: true,
		showOccupation: false,
		showNationality: true,
		showLegalCheckBox: true,
		showLegalTextOnly: false,
		showPasswordHint: false,
		showConsentCheckBox: false,
		DOBPattern: 'DD/MM/YYYY',
		occupations: []
	}
};

/**
 * Returns a valid settings for specific country.
 *
 * @param {string} country code.
 * @return {Object} country settings.
 */
function getCountryInfo() {
	var country = arguments.length <= 0 || arguments[0] === undefined ? 'US' : arguments[0];

	return countryInfo[country] ? countryInfo[country] : countryInfo.US;
}

/**
 * Returns a date of birth string depending on the country format.
 *
 * @param {string} date of birth
 * @param {string} country code
 * @return {string} birthDate
 */
function getFormattedDob(dob) {
	var country = arguments.length <= 1 || arguments[1] === undefined ? 'US' : arguments[1];

	var fitDate = '';
	var flatDate = dob.replace(/\D+/g, '').slice(0, 8);
	var pattern = getCountryInfo(country).DOBPattern;

	var j = 0;
	for (var i = 0; i < flatDate.length; i++) {
		if (pattern[j] === '/') {
			fitDate += '/';
			j++;
		}

		fitDate += flatDate[i];
		j++;
	}

	return fitDate;
}

/**
 * Validates date of birth from DoB string.
 *
 * @param {string} date of birth
 * @return {boolean} is valid
 */
function validateDob(dob) {
	var country = arguments.length <= 1 || arguments[1] === undefined ? 'US' : arguments[1];

	var isValid = dob && dob.length === 10 || false;

	if (isValid) {
		var dobDate = dob.split('/');
		var patterns = getCountryInfo(country).DOBPattern.split('/');
		var year = dobDate[patterns.indexOf('YYYY')];
		var month = dobDate[patterns.indexOf('MM')] - 1;
		var day = dobDate[patterns.indexOf('DD')];

		var checkDate = new Date(year, month, day);
		isValid = month === checkDate.getMonth();
	}

	return isValid;
}


//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/guest-payment/dist/util/localizer.js
// module id = 345
// module chunks = 6